export const inputCls = "w-full rounded-xl border border-gray-200 bg-white px-3.5 py-2.5 text-sm font-semibold text-dwc-charcoal outline-none focus:border-dwc-green";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1 block text-[11px] font-extrabold uppercase tracking-wide text-dwc-charcoal/50">{label}</span>
    {children}
  </label>
);

export const Btn = ({ children, onClick, type = "button", variant = "primary", disabled, testId, small }) => {
  const base = small ? "px-3 py-1.5 text-[11px]" : "px-5 py-2.5 text-xs";
  const styles = {
    primary: "bg-dwc-green text-white hover:bg-dwc-green/90",
    outline: "border border-dwc-green/30 bg-white text-dwc-green hover:bg-dwc-soft",
    danger: "border border-red-200 bg-white text-red-600 hover:bg-red-50",
    dark: "bg-dwc-charcoal text-white hover:bg-dwc-charcoal/90",
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled} data-testid={testId}
      className={`rounded-full font-extrabold uppercase tracking-wide transition-colors disabled:opacity-50 ${base} ${styles[variant]}`}>
      {children}
    </button>
  );
};

const STATUS_COLORS = {
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  in_progress: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-gray-100 text-gray-500 border-gray-200",
  missed: "bg-red-50 text-red-600 border-red-200",
  open: "bg-red-50 text-red-600 border-red-200",
  in_review: "bg-amber-50 text-amber-700 border-amber-200",
  resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-600 border-red-200",
  done: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const Badge = ({ value }) => (
  <span className={`inline-flex rounded-full border px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wide ${STATUS_COLORS[value] || "bg-gray-100 text-gray-600 border-gray-200"}`}>
    {String(value || "").replace(/_/g, " ")}
  </span>
);

export const Card = ({ children, className = "", testId }) => (
  <div data-testid={testId} className={`rounded-2xl border border-gray-100 bg-white p-5 ${className}`}>{children}</div>
);

export const CardTitle = ({ children }) => (
  <h3 className="mb-3 text-xs font-extrabold uppercase tracking-wide text-dwc-charcoal/60">{children}</h3>
);

export const StatCard = ({ label, value, testId }) => (
  <Card className="text-center" testId={testId}>
    <p className="text-3xl font-black text-dwc-green">{value}</p>
    <p className="mt-1 text-[10px] font-extrabold uppercase tracking-wide text-dwc-charcoal/50">{label}</p>
  </Card>
);

export const TabBar = ({ tabs, tab, setTab, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {tabs.map(([key, label]) => (
      <button key={key} onClick={() => setTab(key)} data-testid={`${prefix}-tab-${key}`}
        className={`rounded-full px-4 py-2 text-[11px] font-extrabold uppercase tracking-wide transition-colors ${tab === key ? "bg-dwc-green text-white" : "border border-dwc-green/25 bg-white text-dwc-green"}`}>
        {label}
      </button>
    ))}
  </div>
);

export const Empty = ({ children }) => (
  <p className="py-6 text-center text-sm font-semibold text-dwc-charcoal/45">{children}</p>
);

export const Msg = ({ msg }) =>
  msg ? (
    <p data-testid="ops-message" className={`rounded-xl px-4 py-2.5 text-sm font-bold ${msg.ok ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-600"}`}>
      {msg.text}
    </p>
  ) : null;
